import {BoxInputEnum, IBoxEnumEltWedlet} from "back/edit/wed/wedlets/box/boxTags";
import {EPopupType, IPopupable, MxPopupable, OPopupAnchor} from "back/commons/widgets/popupable";
import {IActionableList} from "back/commons/actionables";
import {OPopupMenuInit} from "back/commons/widgets/popups";
import {BaseElement} from "back/commons/basis";
import {GridColTreeDef, GridDataHolderJsonTree, MxGridTreeUntouchedDatas} from "back/commons/widgets/tree";
import {Grid} from "back/commons/widgets/grid-tags";
import {ActionMenu, ActionSeparator, IAction} from "lib/commons/actions";
import {CellBuilderLabel, GridDataRowJson} from "back/commons/widgets/grid-libs";
import {DOM, JSX} from "lib/commons/xml/dom";
import {REG} from "lib/commons/registry";
import {WEDLET} from "back/edit/wed/wedlets/wedlet";
import {IGridLineDrawer} from "back/commons/widgets/grid-core";
import {DOMSH} from "lib/commons/xml/domsh";

class BoxInputEnumLarge extends BoxInputEnum {

	protected _createPopup(): IPopupable & IActionableList<IBoxEnumEltWedlet> {
		const popup = new PopupEnumTree().initialize({
			reg: REG.findReg(this),
			actionContext: this,
			resizer: {}
		});
		popup.onNextClose().then((key: string) => {
			if (key != null && !this.isSelected(key)) WEDLET.replaceValue(this.wedlet, this.key, key);
		});
		return popup;
	}

	async onClick(this: BoxInputEnum, ev: MouseEvent) {
		const popup = this.popup;
		if (popup && !popup.contains(ev.target as Node)) {
			if (!popup.actions) popup.actions = await this.provider.getActions(this);
			popup.show({
				viewPortY: "middle",
				fixSize: true,
				initWidth: "60em"
			}, this);
		}
	}
}

window.customElements.define("box-input-enumlarge", BoxInputEnumLarge);


export interface PopupEnumTree {
	initialize(init?: OPopupEnumTreeInit): this;
}

export interface OPopupEnumTreeInit extends OPopupMenuInit {
	actionContext: BoxInputEnumLarge;
}

export class PopupEnumTree extends MxPopupable(BaseElement, EPopupType.menu) implements IGridLineDrawer, IPopupable<string>, IActionableList<BoxInputEnumLarge> {

	actions: IAction<IBoxEnumEltWedlet>[];

	_actionContext: BoxInputEnumLarge;
	get actionContext(): BoxInputEnumLarge {return this._actionContext};

	dataHolder: GridDataHolderJsonTree<IAction<IBoxEnumEltWedlet>>;

	grid: Grid;
	search: HTMLInputElement;

	protected _initialize(init: OPopupEnumTreeInit) {
		super._initialize(init);
		if ('restoreFocus' in init) this.restoreFocus = init.restoreFocus;
		this._actionContext = init.actionContext;
		this.dataHolder = new DataHolderActions(this.actionContext);
		REG.reg.installSkin("box-input-enumlarge");

		const colDefs = [new GridColTreeDef('tree')
			.setFlex('10rem', 1, 1).setMinWidth('55px')
			.setCellBuilder(new CellBuilderAction(this.actionContext))];

		const searchLabel = this.appendChild(<label id="search"/>)
		this.search = searchLabel.appendChild(<input type="search" spellcheck="false" placeholder="Filtrer..." oninput={this.onSearchInput} onkeydown={this.onKeyPress}/>) as HTMLInputElement;
		this.grid = this.appendChild(new Grid().initialize({
			selType: "monoOver",
			columnDefs: colDefs,
			dataHolder: this.dataHolder,
			lineDrawer: this,
			hideHeaders: true,
			skinScroll: "scroll/small",
			skinOver: "box-input-enumlarge-popup/grid"
		}));

		this.grid.uiEvents.on('rowClick', (row: GridDataRowJson<IAction<IBoxEnumEltWedlet>> | null, ev: MouseEvent) => {
			if (row?.rowDatas.isToggle(this.actionContext) && (ev.target as Element).localName === "span") {
				this.close(row.rowDatas.getId());
			}
		});
		this.grid.addEventListener('keypress', function (this: Grid, ev: KeyboardEvent) {
			const me = this.parentElement as PopupEnumTree;
			if (ev.key === ' ' || ev.key === 'Enter') {
				const row = this.dataHolder.getRow(this.getSelectedRow()) as GridDataRowJson<IAction<IBoxEnumEltWedlet>>;
				if (row?.rowDatas.isToggle(me.actionContext)) me.close(row.rowDatas.getId());
				ev.preventDefault();
			} else me.search.focus();
		});
	}

	protected onSearchInput(this: HTMLInputElement, ev: InputEvent) {
		(this.parentElement.parentElement as PopupEnumTree).redrawDatas();
	}

	protected onKeyPress(this: HTMLInputElement, ev: KeyboardEvent) {
		if (ev.key === 'ArrowDown') {
			const tree = this.parentElement as PopupEnumTree;
			if (tree.grid.dataHolder.countRows() > 0) {
				if (tree.grid.getSelectedRow() === undefined) tree.grid.setSelectedRows(0);
				tree.grid.focus();
			}
		}
	}

	/** */
	redrawLine(row: GridDataRowJson<IAction<IBoxEnumEltWedlet>>, line: HTMLElement): void {
		const d = row.rowDatas;
		DOM.setAttrBool(line, "data-user-disabled", !d.isEnabled(this._actionContext));
		DOM.setAttr(line, "selected", d.isToggle(this._actionContext) ? d.getDatas("toggle", this._actionContext) as any as 'true' | 'false' | 'null' : "null");
	}

	show(anchor?: OPopupAnchor, uiContainer?: Node, logicalParent?: Element): boolean {
		this.redrawDatas();
		return super.show(anchor, uiContainer, logicalParent);
	}

	protected async redrawDatas() {
		const filter = this.search.value;
		if (filter) {
			this.dataHolder.setDefaultOpenState(GridDataHolderJsonTree.defaultOpened as any);
			this.dataHolder.setDatas(await this.actionContext.provider.getActions(this.actionContext, filter));
		} else {
			this.dataHolder.setDefaultOpenState(GridDataHolderJsonTree.defaultClosed as any);
			this.dataHolder.setDatas(this.actions);
		}
	}
}

REG.reg.registerSkin('box-input-enumlarge', 1, /* language=CSS */ `
	#search {
		background: .1em / 1em no-repeat url(/@skin@/commons/icons/filter.svg) var(--form-search-bgcolor);
		padding-inline-start: 1.2em;
	}

	input {
		padding: 2px;
		background: var(--form-search-bgcolor);
		color: var(--form-color);
		border: none;
		width: 100%;
		font-size: inherit;
	}
	input:placeholder-shown{
		font-style: italic;
	}
`);

REG.reg.registerSkin('box-input-enumlarge-popup', 1, /* language=CSS */ `
	:host([opened]) {
		pointer-events: auto;
	}

	#content {
		background-color: var(--row-bgcolor);
		border: solid 1px var(--border-color);
		border-radius: 3px;
		box-shadow: 1px 1px 6px var(--fade-color);
		min-width: 30em;
		min-height: 20em;
	}

	::slotted(c-grid) {
		flex: 1;
	}
`);

REG.reg.registerSkin('box-input-enumlarge-popup/grid', 1, /* language=CSS */ `
	.line:before{
		content: " ";
		min-width: 1rem;
	}
	.line[selected="true"]:before{
		content: "✓";
	}
	.cell {
		display: flex;
	}

	.line[selected="null"] > .cell {
		font-style: italic;
	}
	.line[selected="true"] > .cell,
	.line[selected="false"] > .cell {
		cursor: pointer;
	}

	span {
		flex: 1;
	  white-space: normal;
  }

  .sep {
	  display: flex;
  }

  *[data-user-disabled] {
	  opacity: .5;
	  pointer-events: none;
  }

  .sep > span {
	  border-bottom: solid 1px var(--border-color);
	  flex: 1;
	  height: 1px;
  }
`);

window.customElements.define("box-input-enumlarge-popup", PopupEnumTree);

class DataHolderActions extends MxGridTreeUntouchedDatas(GridDataHolderJsonTree)<IAction<IBoxEnumEltWedlet>> {
	actionContext: IBoxEnumEltWedlet;

	constructor(actionContext: IBoxEnumEltWedlet) {
		super();
		this.actionContext = actionContext;
	}

	ch(parent: IAction<IBoxEnumEltWedlet>): IAction<IBoxEnumEltWedlet>[] | undefined | null {
		if (!parent.isMenu(this.actionContext)) return undefined;
		return (parent.getDatas("menu", this.actionContext) || []) as IAction<IBoxEnumEltWedlet>[];
	}

	setCh(parent: IAction<IBoxEnumEltWedlet>, ch: IAction<IBoxEnumEltWedlet>[] | null): IAction<IBoxEnumEltWedlet>[] | null {
		(parent as ActionMenu<IBoxEnumEltWedlet>).setActions(ch);
		return ch;
	}
}

class CellBuilderAction<C> extends CellBuilderLabel /*CellBuilderIconLabel*/ {
	ctx: C;

	constructor(actionContext: C) {
		super('');
		this.ctx = actionContext;
	}

	redrawCell(row: GridDataRowJson<IAction<C>>, root: HTMLElement) {
		if (row.rowDatas instanceof ActionSeparator) {
			root.parentElement.classList.toggle("sep", true);
			DOM.setTextContent(root, null);
			DOM.setAttr(root, "title", null);
		} else {
			root.parentElement.classList.toggle("sep", false);
			super.redrawCell(row, root);
		}
	}

	protected _getValue(row: GridDataRowJson<IAction<C>>): any {
		return row.rowDatas.getLabel(this.ctx);
	}

	// protected _getIcon(row: GridDataRowJson<IAction<C>>): string {
	// 	return row.rowDatas.getIcon(this.ctx);
	// }

	protected _getDescription(row: GridDataRowJson<IAction<C>>): any {
		return row.rowDatas.getDescription(this.ctx);
	}

}